import React from 'react';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'center',
                    justifyContent: 'center', minHeight: '100vh', padding: '40px',
                    fontFamily: 'sans-serif', color: '#1e293b'
                }}>
                    <h2 style={{ marginBottom: 12 }}>Something went wrong</h2>
                    <p style={{ color: '#64748b', marginBottom: 24 }}>
                        An unexpected error occurred. Please refresh the page.
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            padding: '10px 24px', background: '#3b82f6', color: '#fff',
                            border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14
                        }}
                    >
                        Refresh Page
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}
